var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',{attrs:{"type":_vm.typeChart,"data":_vm.dataChart,"options":_vm.optionsChart,"width":_vm.widthChart,"height":_vm.heightChart,"plugins":_vm.pluginsChart}})}
var staticRenderFns = []

export { render, staticRenderFns }